export const ruFields: Record<string, string> = {
  sheetId: 'Лист',
  sectionId: 'Раздел',
  projectId: 'Проект',
  providerAccountId: 'Провайдер',
  paymentPeriodId: 'Период оплаты',
  paymentMethodId: 'Способ оплаты',
  relevanceId: 'Актуальность',
  statusId: 'Рабочий статус',
  responsibleAccountId: 'Ответственный',
  serviceTypeId: 'Тип услуги',
  ip: 'IP-адрес',
  host: 'Хост',
  port: 'Порт',
  protocol: 'Протокол',
  domain: 'Домен',
  priceKind: 'Стоимость',
  cost: 'Стоимость за период',
  paidUntil: 'Оплачен до',
  autoRenew: 'Автопродление',
  targetResourceId: 'Связанный ресурс',
  last4: 'Последние четыре цифры',
  workAreas: 'Доступные пространства',
  occurredAt: 'Дата события',
  aggregateType: 'Раздел',
  reviewerAccountId: 'Учётная запись руководителя',
  policyVersion: 'Версия политики',
  applicationVersion: 'Версия отклика',
  category: 'Категория',
  DELIVERABLES: 'Результаты работы',
  SKILLS: 'Навыки',
  VALUES: 'Ценности',
  activatedAt: 'Дата активации',
  providerReferenceMasked: 'Номер у провайдера',
  requisitionId: 'Заявка на найм',
  name: 'Название',
  title: 'Название',
  code: 'Код',
  type: 'Тип',
  status: 'Статус',
  email: 'Электронная почта',
  login: 'Логин',
  text: 'Текст',
  body: 'Текст',
  description: 'Описание',
  reason: 'Причина',
  comment: 'Комментарий',
  language: 'Язык',
  country: 'Код страны',
  jurisdiction: 'Юрисдикция',
  purpose: 'Цель обработки',
  phone: 'Телефон',
  primaryEmail: 'Электронная почта',
  source: 'Источник',
  currentEmployer: 'Текущее место работы',
  tags: 'Метки',
  processingStatus: 'Обработка данных',
  approvalStatus: 'Согласование',
  lifecycleStatus: 'Состояние',
  publicationStatus: 'Публикация',
  audience: 'Аудитория',
  confidential: 'Конфиденциальная вакансия',
  internalTitle: 'Внутреннее название',
  publicTitle: 'Публичное название',
  organizationId: 'Организация',
  departmentId: 'Отдел',
  primaryTeamId: 'Основной проект',
  additionalTeamIds: 'Дополнительные проекты',
  teamIds: 'Проекты',
  jobFunctionId: 'Направление работы',
  rank: 'Порядок уровня',
  countryCode: 'Страна',
  specialisationId: 'Специализация',
  specialisationIds: 'Специализации',
  seniorityId: 'Уровень',
  seniorityIds: 'Уровни',
  minSeniorityId: 'Минимальный уровень',
  maxSeniorityId: 'Максимальный уровень',
  minSeniority: 'Минимальный уровень',
  maxSeniority: 'Максимальный уровень',
  locationId: 'Локация',
  locationIds: 'Локации',
  locations: 'Локации',
  ownerEmployeeId: 'Ответственный',
  managerEmployeeId: 'Руководитель проекта',
  lineManagerId: 'Непосредственный руководитель',
  functionalManagerId: 'Функциональный руководитель',
  buddyId: 'Наставник',
  employeeId: 'Сотрудник',
  patch: 'Поля для изменения',
  employees: 'Сотрудники',
  hrOwnerId: 'Ответственный HR',
  managerId: 'Руководитель',
  recruiterId: 'Рекрутер',
  hiringManagerIds: 'Нанимающие руководители',
  headcountAllocationIds: 'Штатные единицы',
  requisitionIds: 'Заявки на найм',
  candidateId: 'Кандидат',
  jobPostingId: 'Вакансия',
  applicationId: 'Отклик',
  assigneeEmployeeId: 'Исполнитель',
  interviewerIds: 'Интервьюеры',
  interviewerId: 'Интервьюер',
  assigneeRule: 'Правило назначения',
  templateVersionId: 'Опубликованный шаблон процесса',
  permissionGroupIds: 'Группы доступа',
  permissionGroupId: 'Группа доступа',
  toStageId: 'Следующий этап',
  startDate: 'Дата выхода',
  startsAt: 'Дата и время начала',
  contractEndDate: 'Дата окончания договора',
  workName: 'Имя',
  workEmail: 'Рабочая почта',
  workTelegram: 'Рабочий Telegram',
  personalTelegram: 'Личный Telegram',
  positionId: 'Должность',
  workFormat: 'Формат работы',
  endDate: 'Дата завершения',
  employeeNumber: 'Порядковый номер сотрудника',
  jobTitle: 'Должность',
  employmentType: 'Тип занятости',
  externalEmployee: 'Внешний сотрудник',
  accessEndsAt: 'Дата отключения доступа',
  expectedStartDate: 'Ожидаемая дата выхода',
  lastWorkingDate: 'Последний рабочий день',
  targetStartDate: 'Планируемая дата выхода',
  hiringReason: 'Причина найма',
  terminationType: 'Тип увольнения',
  privacyNoticeVersionId: 'Уведомление об обработке данных',
  noticeVersionId: 'Версия уведомления',
  processingBasisPolicyVersionId: 'Политика обработки',
  privacyNoticeDelivery: 'Предоставление уведомления',
  consentEvidence: 'Подтверждение согласия',
  consentRequired: 'Требуется согласие',
  evidence: 'Подтверждение',
  evidenceTextHash: 'Контрольная сумма подтверждения',
  processingBasisRecordId: 'Основание обработки',
  deliveredAt: 'Дата предоставления',
  channel: 'Канал',
  channels: 'Каналы публикации',
  legalApprovalReference: 'Реквизиты юридического согласования',
  rules: 'Правила',
  basis: 'Основание обработки',
  basisType: 'Основание',
  expiresAfterDays: 'Срок хранения, дней',
  effectiveAt: 'Дата вступления в силу',
  effectiveDate: 'Дата начала действия',
  effectiveFrom: 'Действует с',
  effectiveTo: 'Действует до',
  expiresAt: 'Срок действия',
  expiresOn: 'Действует до',
  copyFromVersionId: 'Исходная версия',
  profileVersionId: 'Версия профиля должности',
  roleProfileVersionId: 'Профиль должности',
  evaluationTemplateVersionId: 'Версия шаблона оценки',
  scorecardTemplateVersionId: 'Шаблон оценки интервью',
  emailTemplateVersionId: 'Шаблон письма',
  recipientEmail: 'Почта получателя',
  publishedAt: 'Дата публикации',
  releasedAt: 'Дата снятия приостановки',
  createdAt: 'Дата создания',
  updatedAt: 'Дата изменения',
  lastLoginAt: 'Последний вход',
  decidedAt: 'Дата решения',
  completedAt: 'Дата завершения',
  dueAt: 'Срок выполнения',
  dueDate: 'Срок выполнения',
  dueOffsetDays: 'Смещение срока, дней',
  durationDays: 'Длительность, дней',
  durationMinutes: 'Длительность, минут',
  meetingUrl: 'Ссылка на встречу',
  timezone: 'Часовой пояс',
  defaultLocale: 'Язык по умолчанию',
  outcome: 'Результат',
  result: 'Результат',
  absentParty: 'Кто не явился',
  recommendation: 'Рекомендация',
  compensation: 'Вознаграждение',
  amount: 'Сумма',
  currency: 'Валюта',
  frequency: 'Периодичность',
  positions: 'Количество мест',
  capacity: 'Количество мест',
  answers: 'Ответы',
  questionId: 'Вопрос',
  questionVersionId: 'Версия вопроса',
  value: 'Значение',
  values: 'Значения',
  employee: 'Сотрудник',
  employeeVisible: 'Видно сотруднику',
  feedbackEmployeeVisible: 'Обратная связь видна сотруднику',
  sections: 'Разделы',
  stages: 'Этапы',
  tasks: 'Задачи',
  key: 'Ключ',
  order: 'Порядок',
  questions: 'Вопросы',
  options: 'Варианты',
  label: 'Название',
  required: 'Обязательное поле',
  mandatory: 'Обязательно',
  isRequired: 'Обязательно',
  dataType: 'Тип данных',
  taskType: 'Тип задачи',
  dependencyKeys: 'Зависимости задач',
  min: 'Минимум',
  max: 'Максимум',
  minLength: 'Минимальная длина',
  maxLength: 'Максимальная длина',
  minFiles: 'Минимум файлов',
  maxFiles: 'Максимум файлов',
  maxFileSizeBytes: 'Размер файла, байт',
  allowedMimeTypes: 'Разрешённые типы файлов',
  permission: 'Разрешение',
  scope: 'Область доступа',
  scopeEntityId: 'Объект области доступа',
  grants: 'Разрешения',
  effect: 'Решение',
  entityType: 'Тип объекта',
  entityId: 'Объект',
  targetEntityType: 'Тип объекта',
  targetEntityId: 'Объект',
  mission: 'Назначение должности',
  skills: 'Навыки',
  skillId: 'Навык',
  skillVersionId: 'Версия навыка',
  criteria: 'Критерии',
  criterionId: 'Критерий',
  indicators: 'Индикаторы',
  level: 'Уровень',
  levels: 'Уровни',
  expectedLevel: 'Ожидаемый уровень',
  expectedResult: 'Ожидаемый результат',
  expected: 'План',
  actual: 'Факт',
  acceptanceCriteria: 'Критерии приёмки',
  weight: 'Вес',
  grades: 'Оценки',
  grade: 'Оценка',
  score: 'Баллы',
  strengths: 'Сильные стороны',
  development: 'Зоны развития',
  masteryMapping: 'Соответствие уровням владения',
  skillExpectations: 'Ожидания по навыкам',
  evaluationTemplate: 'Шаблон оценки',
  questionGroups: 'Группы вопросов',
  selfReviewRequired: 'Обязательная самооценка',
  reviewerType: 'Тип оценщика',
  reviewerTypes: 'Типы оценщиков',
  sectionWeights: 'Веса разделов',
  content: 'Содержание',
  definition: 'Описание',
  originalDefinition: 'Исходное описание',
  sourceTaskKey: 'Задача шаблона',
  taskKey: 'Ключ задачи',
  startsFrom: 'Отсчёт от',
  periodStart: 'Начало периода',
  periodEnd: 'Конец периода',
  reviewOpenAt: 'Открытие оценки',
  reviewDueAt: 'Срок оценки',
  cycleId: 'Цикл оценки',
  assignmentId: 'Назначение профиля',
  planId: 'Рабочий план',
  progressPercent: 'Прогресс',
  coverage: 'Полнота оценки',
  finalGrade: 'Итоговая оценка',
  finalReason: 'Обоснование оценки',
  roleChanged: 'Должность изменена',
  versionNumber: 'Номер версии',
  legalFirstName: 'Имя по документам',
  legalLastName: 'Фамилия по документам',
  preferredName: 'Предпочитаемое имя',
  birthDate: 'Дата рождения',
  nationality: 'Гражданство',
  personalEmail: 'Личная почта',
  personalPhone: 'Личный телефон',
  payrollGroup: 'Группа расчёта зарплаты',
  providerReference: 'Номер у провайдера',
  checkedAt: 'Дата проверки',
  externalReference: 'Внешний номер',
  fileId: 'Файл',
  fileVersionId: 'Версия файла',
  fileIds: 'Файлы',
  actorAccountId: 'Пользователь',
  actorId: 'Пользователь',
  actorType: 'Тип пользователя',
  action: 'Действие',
  eventType: 'Событие',
  currentStageId: 'Текущий этап',
  statusReason: 'Причина статуса',
  accountId: 'Учётная запись',
  policyId: 'Политика',
  policyVersionId: 'Версия политики',
  catalogId: 'Каталог',
  currentVersionId: 'Текущая версия',
  currentPublishedVersionId: 'Опубликованная версия',
  grantedAt: 'Дата предоставления',
  validFrom: 'Начало действия',
  validUntil: 'Конец действия',
  dryRun: 'Предварительная проверка',
  purposeCode: 'Цель обработки',
  primaryCandidateId: 'Основной кандидат',
  mergedCandidateIds: 'Дубликаты кандидата',
  recordedAt: 'Дата записи',
  acceptedAt: 'Дата принятия',
  submittedAt: 'Дата отправки',
  isCurrent: 'Текущая оценка',
  evidenceRequired: 'Требуется подтверждение',
  resourceType: 'Тип данных',
  resources: 'Объекты',
  filters: 'Фильтры',
  filter: 'Фильтр',
  format: 'Формат',
  schemaVersion: 'Версия схемы',
  revision: 'Редакция',
  method: 'Способ',
  decision: 'Решение',
  asOf: 'На дату',
  reviewId: 'Оценка',
  submissionVersion: 'Версия оценки',
  expectedEmployeeVersion: 'Версия профиля сотрудника',
  replacesPlanId: 'Заменяемый план',
  correctsReviewId: 'Исправляемая оценка',
  registrationDeliveryStatus: 'Доставка приглашения',
};
export const ruValues: Record<string, string> = {
  ADMINISTRATIVE: 'Административный отдел',
  WORKER: 'Фоновая задача',
  INTERVIEW: 'Интервью',
  Workspace: 'Рабочее пространство',
  Organization: 'Организация',
  Department: 'Отдел',
  Team: 'Проект',
  Employee: 'Сотрудник',
  Candidate: 'Кандидат',
  Application: 'Отклик',
  JobPosting: 'Вакансия',
  Requisition: 'Заявка на найм',
  BulkOperation: 'Фоновая операция',
  Offer: 'Оффер',
  Account: 'Учётная запись',
  PermissionGroup: 'Группа доступа',
  FileObject: 'Файл',
  Review: 'Оценка',
  WorkPlan: 'Рабочий план',
  ACTIVE: 'Активно',
  JOINING: 'Ожидает выхода',
  OFFBOARDING: 'Офбординг',
  PROBATION: 'На испытательном сроке',
  ON_LEAVE: 'В отпуске',
  OFFICE: 'Office',
  REMOTE: 'Remote',
  HYBRID: 'Hybrid',
  INACTIVE: 'Уволен',
  DRAFT: 'Черновик',
  PENDING: 'Ожидает',
  PENDING_APPROVAL: 'На согласовании',
  APPROVED: 'Согласовано',
  REJECTED: 'Отклонено',
  OPEN: 'Открыто',
  ON_HOLD: 'Приостановлено',
  CLOSED: 'Закрыто',
  ARCHIVED: 'В архиве',
  UNPUBLISHED: 'Не опубликовано',
  PUBLISHING: 'Публикуется',
  PUBLISHED: 'Опубликовано',
  PARTIALLY_PUBLISHED: 'Частично опубликовано',
  FAILED: 'Ошибка',
  PENDING_ACTIVATION: 'Ожидает активации',
  BLOCKED: 'Заблокировано',
  DISABLED: 'Отключено',
  ACTIVE_MEMBERS_BLOCK_ARCHIVE: 'Есть активные участники',
  IN_PROGRESS: 'В работе',
  COMPLETED: 'Завершено',
  CANCELLED: 'Отменено',
  PENDING_FILE_SCAN: 'Проверка файлов',
  RESTRICTED: 'Обработка ограничена',
  ERASURE_PENDING: 'Ожидает удаления',
  ANONYMIZED: 'Обезличено',
  ACTIVE_PLAN_EXISTS: 'Есть действующий план',
  WITHDRAWN: 'Отозвано',
  OFFER: 'Оффер',
  HIRED: 'Нанят',
  SCHEDULED: 'Запланировано',
  NO_SHOW: 'Неявка',
  NOT_SENT: 'Не отправлено',
  DELIVERY_QUEUED: 'В очереди на отправку',
  SENDING: 'Отправляется',
  DELIVERY_FAILED: 'Ошибка доставки',
  SENT: 'Отправлено',
  VIEWED: 'Просмотрено',
  ACCEPTED: 'Принято',
  DECLINED: 'Отклонено кандидатом',
  EXPIRED: 'Срок истёк',
  SCANNING: 'Проверка',
  UPLOADED: 'Загружено',
  CLEAN: 'Проверено',
  INFECTED: 'Обнаружена угроза',
  QUARANTINED: 'Карантин',
  SCAN_FAILED: 'Ошибка проверки',
  QUEUED: 'В очереди',
  VALIDATING: 'Проверка данных',
  RUNNING: 'Выполняется',
  PARTIALLY_COMPLETED: 'Частично завершено',
  RETIRED: 'Снято с использования',
  IN_REVIEW: 'На оценке',
  READY: 'Готово',
  SUBMITTED: 'Отправлено',
  AVAILABLE: 'Доступно',
  NOT_CONFIGURED: 'Не настроено',
  ASSIGNED: 'Назначено',
  REVOKED: 'Отозвано',
  COMPROMISED: 'Скомпрометировано',
  DIRECT_APPLICATION: 'Прямой отклик',
  RECRUITER: 'Рекрутер',
  IMPORT: 'Импорт',
  REFERRAL: 'Рекомендация',
  INTERNAL: 'Внутренняя',
  PUBLIC: 'Публичная',
  BOTH: 'Оба варианта',
  FULL_TIME: 'Full-time',
  PART_TIME: 'Part-time',
  CONTRACTOR: 'Contractor',
  INTERN: 'Стажёр',
  TEMPORARY: 'Временная занятость',
  WORKSPACE: 'Рабочее пространство',
  ORGANIZATION: 'Организация',
  DEPARTMENT: 'Отдел',
  TEAM: 'Проект',
  SELF: 'Сам пользователь',
  DIRECT_REPORTS: 'Подчинённые',
  ASSIGNED_ENTITIES: 'Назначенные объекты',
  ALLOW: 'Разрешить',
  DENY: 'Запретить',
  ONBOARDING: 'Онбординг',
  HR: 'HR',
  OWNER: 'Ответственный подразделения',
  UNIT_OWNER: 'Ответственный подразделения',
  BUDDY: 'Наставник',
  LINE_MANAGER: 'Непосредственный руководитель',
  FUNCTIONAL_MANAGER: 'Функциональный руководитель',
  CUSTOM: 'Пользовательский',
  CANDIDATE: 'Кандидат',
  INTERVIEWER: 'Интервьюер',
  STRONG_HIRE: 'Однозначно нанимать',
  HIRE: 'Нанимать',
  NO_HIRE: 'Не нанимать',
  STRONG_NO_HIRE: 'Однозначно не нанимать',
  FILLED: 'Закрыта наймом',
  FROZEN: 'Заморожено',
  CLOSED_WITHOUT_HIRE: 'Закрыто без найма',
  PASSED: 'Пройдено',
  VERIFIED: 'Подтверждено',
  HOURLY: 'За час',
  MONTHLY: 'За месяц',
  ANNUAL: 'За год',
  LEGAL_OBLIGATION: 'Юридическое обязательство',
  LEGITIMATE_INTEREST: 'Законный интерес',
  PRE_CONTRACTUAL: 'Заключение договора',
  CONSENT: 'Согласие',
  PUBLIC_FORM: 'Публичная форма',
  EMAIL: 'Электронная почта',
  TOTP: 'Приложение-аутентификатор',
  RECORDED_BY_RECRUITER: 'Зафиксировано рекрутером',
  CANDIDATE_REQUEST: 'Запрос кандидата',
  SHORT_TEXT: 'Короткий текст',
  LONG_TEXT: 'Длинный текст',
  TEXT: 'Текст',
  BOOLEAN: 'Да / нет',
  DATE: 'Дата',
  CHOICE: 'Выбор',
  SINGLE_CHOICE: 'Один вариант',
  MULTI_CHOICE: 'Несколько вариантов',
  FILE: 'Файл',
  FILES: 'Файлы',
  DOCUMENT: 'Документ',
  FORM: 'Форма',
  ACTION: 'Действие',
  ASSESSMENT: 'Оценка',
  CONFIRMATION: 'Подтверждение',
  ACCESS: 'Доступ',
  SCREENING: 'Проверка',
  RIGHT_TO_WORK: 'Право на работу',
  REQUIRED: 'Обязательно',
  SKIPPED: 'Пропущено',
  RETURNED_ONCE: 'Возвращено на доработку',
  EXCLUDED: 'Исключено',
  RELEASED: 'Освобождено',
  RESERVED: 'Зарезервировано',
  OCCUPIED: 'Занято',
  VALID: 'Действует',
  TODO: 'К выполнению',
  POOR: 'Начальный',
  BASIC: 'Базовый',
  INTERMEDIATE: 'Средний',
  ADVANCED: 'Продвинутый',
  EXPERT: 'Экспертный',
  SCALE: 'Шкала',
  SKILL: 'Навык',
  ROLE_PROFILE: 'Профиль должности',
  EVALUATION: 'Оценка',
  DELIVERABLES: 'Результаты работы',
  SKILLS: 'Навыки',
  VALUES: 'Ценности',
  ACCOUNT: 'Учётная запись',
  SERVICE_ACCOUNT: 'Сервисная учётная запись',
  PERMISSION_GROUP: 'Группа доступа',
  SYSTEM: 'Система',
  TEMPLATE: 'Шаблон',
  REVIEW: 'Оценка',
  PERFORMANCE: 'Эффективность',
  RECRUITMENT: 'Подбор персонала',
  OFFERS: 'Офферы',
  INTERVIEWS: 'Интервью',
  APPROVALS: 'Согласования',
  CREATED: 'Создано',
  UPDATED: 'Изменено',
  DELETE: 'Удаление',
  ANONYMIZE: 'Обезличивание',
  SECURITY_ACCOUNT: 'Безопасность учётной записи',
  SECURITY_LOGIN: 'Вход в систему',
  HR_PROFILE: 'Профиль сотрудника',
  INFO: 'Информация',
  WARNING: 'Предупреждение',
  CRITICAL: 'Критично',
  CSV: 'CSV',
  XLSX: 'XLSX',
};
export function auditEventLabel(value: string): string {
  const [domain, action] = value.split('.');
  const domains: Record<string, string> = {
    account: 'Учётная запись',
    auth: 'Вход и безопасность',
    session: 'Сессия',
    employee: 'Сотрудник',
    organization: 'Организация',
    department: 'Отдел',
    team: 'Проект',
    requisition: 'Заявка на найм',
    job_posting: 'Вакансия',
    candidate: 'Кандидат',
    application: 'Отклик',
    interview: 'Интервью',
    offer: 'Оффер',
    onboarding: 'Адаптация',
    offboarding: 'Увольнение',
    file: 'Файл',
    review: 'Оценка',
    work_plan: 'Рабочий план',
    work_task: 'Рабочая задача',
    performance_cycle: 'Цикл оценки',
    skill: 'Навык',
    role_profile: 'Профиль должности',
    employee_evaluation_template: 'Шаблон оценки',
    permission_group: 'Группа доступа',
    permission_assignment: 'Назначение прав',
    permission_override: 'Исключение прав',
    service_account: 'Сервисная учётная запись',
    privacy_notice: 'Уведомление о данных',
    processing_basis_policy: 'Политика обработки данных',
    audit: 'Журнал аудита',
    export: 'Экспорт',
    retention_policy: 'Хранение данных',
    legal_hold: 'Приостановка удаления',
    notification: 'Уведомление',
  };
  const actions: Record<string, string> = {
    work_areas_changed: 'изменение доступа к пространствам',
    created: 'создание',
    version_created: 'создание версии',
    updated: 'изменение',
    published: 'публикация',
    activated: 'активация',
    archived: 'архивация',
    viewed: 'просмотр',
    read: 'просмотр',
    completed: 'завершение',
    cancelled: 'отмена',
    submitted: 'отправка',
    approved: 'согласование',
    rejected: 'отклонение',
    withdrawn: 'отзыв',
    accepted: 'принятие',
    declined: 'отклонение',
    opened: 'открытие',
    closed: 'закрытие',
    blocked: 'блокировка',
    unblocked: 'снятие блокировки',
    disabled: 'отключение',
    reactivated: 'восстановление',
    access_extended: 'продление доступа',
    access_extension_cancelled: 'отмена продления доступа',
    feedback_submitted: 'обратная связь',
    import_requested: 'импорт',
    merged: 'объединение',
    metadata_viewed: 'просмотр данных файла',
    download_requested: 'скачивание',
    download_url_issued: 'скачивание',
    uploaded: 'загрузка',
    password_changed: 'изменение пароля',
    password_reset_requested: 'сброс пароля',
    login_succeeded: 'вход',
    login_failed: 'неудачная попытка входа',
    restricted_viewed: 'просмотр ограниченных данных',
    assigned: 'назначение',
    returned: 'возврат на доработку',
    finalized: 'итоговая оценка',
    started: 'начало работы',
    progress_updated: 'обновление результата',
    revoked: 'отзыв доступа',
    rotated: 'обновление ключа',
    released: 'снятие ограничения',
  };
  return `${domains[domain || ''] || 'Платформа'}: ${actions[action || ''] || 'изменение состояния'}`;
}
export const errorMessages: Record<string, string> = {
  AUTH_INVALID_CREDENTIALS: 'Неверная почта или пароль',
  AUTH_MFA_INVALID: 'Неверный код подтверждения',
  AUTH_MFA_NOT_ENROLLED: 'Способ подтверждения не подключён',
  AUTH_TOKEN_EXPIRED: 'Срок действия ссылки истёк',
  AUTH_TOKEN_INVALID: 'Ссылка или сессия недействительна',
  ACCOUNT_BLOCKED: 'Учётная запись заблокирована',
  ACCOUNT_DISABLED: 'Учётная запись отключена',
  ACCOUNT_PENDING_ACTIVATION: 'Активируйте учётную запись по ссылке из письма',
  PERMISSION_DENIED: 'Недостаточно прав для этого действия',
  RESOURCE_NOT_FOUND: 'Запись не найдена',
  VERSION_CONFLICT: 'Запись уже изменена. Обновите страницу и повторите действие',
  INVALID_STATE_TRANSITION: 'Действие недоступно в текущем состоянии',
  DUPLICATE_CANDIDATE: 'Кандидат с такой почтой уже существует',
  EMAIL_ALREADY_EXISTS: 'Эта почта уже используется',
  ORGANIZATION_ALREADY_EXISTS:
    'В рабочем пространстве уже есть активная организация. Измените её название в карточке организации.',
  PROCESSING_BASIS_UNRESOLVED:
    'Настройте активную политику обработки данных для этого источника, цели и юрисдикции',
  PRIVACY_NOTICE_REQUIRED: 'Требуется опубликованное уведомление об обработке данных',
  ROLE_PROFILE_NOT_CONFIGURED: 'Для этой должности не настроен опубликованный профиль',
  FILE_NOT_CLEAN: 'Файл ещё не прошёл проверку безопасности',
  FILE_TOO_LARGE: 'Файл превышает допустимый размер',
  FILE_TYPE_UNSUPPORTED: 'Этот тип файла не поддерживается',
  RATE_LIMITED: 'Слишком много запросов. Попробуйте позже',
  CSRF_INVALID: 'Сессия устарела. Войдите повторно',
  SERVICE_UNAVAILABLE: 'Сервис временно недоступен',
  IMMUTABLE_VERSION: 'Опубликованную версию нельзя изменить. Создайте новую',
  VALIDATION_FAILED: 'Проверьте заполненные поля',
};
export function statusLabel(value: string): string {
  return ruValues[value] || 'Неизвестный статус';
}
export function fieldLabel(value: string): string {
  return ruFields[value] || 'Параметр';
}

export function permissionLabel(permission: string): string {
  const parts = permission.split('.');
  const operation = parts.at(-1) || 'read';
  const nouns: Record<string, string> = {
    accounts: 'учётные записи',
    workspace: 'рабочее пространство',
    organization: 'организация',
    departments: 'отделы',
    projects: 'проекты',
    positions: 'должности',
    locations: 'локации',
    seniorities: 'уровни',
    employees: 'сотрудники',
    permissions: 'разрешения',
    service_accounts: 'сервисные учётные записи',
    requisitions: 'заявки на найм',
    job_postings: 'вакансии',
    candidates: 'кандидаты',
    interviews: 'интервью',
    offers: 'офферы',
    onboarding: 'онбординг',
    offboarding: 'офбординг',
    files: 'файлы',
    exports: 'экспорт',
    audit: 'журнал аудита',
    retention: 'хранение данных',
    legal_holds: 'запреты на удаление',
    privacy_notices: 'уведомления о данных',
    processing_basis_policies: 'политики обработки',
    performance_templates: 'шаблоны оценки',
    work_plans: 'рабочие планы',
    performance_reviews: 'оценка сотрудников',
    personal: 'личные данные',
    documents: 'документы',
    screening: 'проверки',
    payroll: 'расчёт зарплаты',
    compensation: 'вознаграждение',
  };
  const verbs: Record<string, string> = {
    read: 'Просмотр',
    manage: 'Управление',
    create: 'Создание',
    edit: 'Редактирование',
    archive: 'Архивирование',
    delete: 'Удаление',
    bulk: 'Массовое изменение',
    write: 'Изменение',
    approve: 'Согласование',
    publish: 'Публикация',
    schedule: 'Планирование',
    own: 'Собственная обратная связь',
    all: 'Вся обратная связь',
    merge: 'Объединение',
    import: 'Импорт',
    upload: 'Загрузка',
    run: 'Запуск',
    update_own: 'Изменение своих данных',
    write_own: 'Собственная оценка',
  };
  const hrNouns: Record<string, string> = {
    departments: 'отделов',
    projects: 'проектов',
    positions: 'должностей',
    locations: 'локаций',
    seniorities: 'уровней',
    employees: 'сотрудников',
  };
  if (
    hrNouns[parts[0] || ''] &&
    ['read', 'create', 'edit', 'archive', 'delete', 'import'].includes(operation)
  )
    return `${verbs[operation]} ${hrNouns[parts[0]!]}`;
  return `${verbs[operation] || 'Управление'}: ${nouns[parts[0] === 'employee_fields' ? parts[1]! : parts[0]!] || 'данные платформы'}`;
}

const permissionGroupNames: Record<string, string> = {
  'System Admin': 'Администратор',
  'HR Admin': 'HR-администратор',
  HR: 'HR',
  Recruiter: 'HR / Рекрутер',
  Manager: 'Руководитель',
  'Hiring Manager': 'Руководитель',
  Employee: 'Сотрудник',
  'Recruitment Admin': 'Администратор подбора',
  Interviewer: 'Интервьюер',
  'Onboarding/Offboarding Manager': 'Ответственный за онбординг и офбординг',
};
export function permissionGroupLabel(name: string) {
  return permissionGroupNames[name] || name;
}
